module.exports = __webpack_public_path__ + "img/client-5.c684cc75.jpg";